import { Typography } from '@mui/material'

export interface HeatIntensity {
  status: string
  text: string
}

export interface TypeHeatIntensityProps {
  value?: HeatIntensity | null
}

export const TypeHeatIntensity = ({ value }: TypeHeatIntensityProps) => {
  if (!value?.text) {
    return '-'
  }

  return <Typography>{value.text}</Typography>
}
